'use strict';

FilterContainerDirective.$inject = [];

export function FilterContainerDirective() {
  return {
    restrict: 'A',
    controller: FilterContainerController
  }
}

FilterContainerController.$inject = [
  '$scope',
];

function FilterContainerController($scope) {
  this.getFilterScope = getFilterScope;

  function getFilterScope() {
    return $scope;
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/filters/FilterContainerDirective.js